import { AxiosPromise } from 'axios';
import Http from '../../shared/http';
import {
  NodeData,
  API_PATH_NODES,
  API_PATH_NODES2,
} from './nodes.types';
import { ServerResponse } from '../types';

const http = Http.getHttp();

// eslint-disable-next-line import/prefer-default-export
export function getNodes(deliveryFunctionId: string): AxiosPromise<ServerResponse<NodeData>> {
  return http.get(`${API_PATH_NODES}/${deliveryFunctionId}`);
}

export function getNodes2(deliveryFunctionId: string): AxiosPromise<ServerResponse<NodeData>> {
  return http.get(`${API_PATH_NODES2}/${deliveryFunctionId}`);
}
